import { useTranslation } from "react-i18next";

/**
 * A custom hook to translate raw coupon codes into human-readable labels.
 * Especially useful for internal/virtual coupons generated by the backend.
 */
export const useCouponLabel = () => {
  const { t } = useTranslation();

  const getCouponLabel = (code: string): string => {
    // We normalize to lowercase for safe matching
    switch (code.toLowerCase()) {
      case "havale_indirimi":
        return t("cartTotals.coupons.bacsDiscount", "BACS Discount");
      case "ilk_siparis_promosyonu":
        return t("cartTotals.coupons.firstPurchase", "First Purchase Discount");
      case "harcadikca_kazan_indirimi":
        return t("cartTotals.coupons.spendAndSave", "Spend & Save Discount");
      default:
        // For standard coupons entered by the user, just return the UPPERCASE code
        return code.toUpperCase();
    }
  };

  return { getCouponLabel };
};
